const utils = {
    ID() {
        return '_' + Math.random().toString(36).substr(2, 9);
    },
    format_number(number) {
        return ('0' + number).slice(-2);
    },
    reset_client() {
        if(window.wso){
            window.wso.close();
        }
        localStorage.removeItem("session");
        sessionStorage.removeItem("event_session");
        window.location.href = "/";
    },
    // Online-mode logout - the online session lives entirely in the REST
    // world (see client/src/api.js, store/index.js's online_user/
    // online_session), so unlike reset_client() this never touches the
    // websocket and doesn't need a hard reload.
    reset_online_client() {
        localStorage.removeItem("online_session");
        window.store.commit("clearOnlineAuth");
        window.router.push({name: "Home"});
    },
    get_choice_character(idx){
        return "ABCDEFGHIJKLMNÑOPQRSTUVWXYZ".charAt(idx);
    },
    get_activity(user, question_id){
        let found_user = window.store.state.game.clients.find((u) => u.username == user);
        if(found_user != null && typeof found_user !== undefined)
        {
            if(typeof found_user.data !== undefined)
            {
                if(found_user.data.length > 0)
                {
                    let activity = found_user.data.find((act) => act.question == question_id);
                    if(activity != null && typeof activity !== undefined)
                        return activity;

                    return null;
                }
                return null;
            }
            return null;
        }
        //if()
        return null;
    },
    USER_ROLES : {
        SUPER_ADMINISTRATOR:    0,
        ADMINISTRATOR:          1,
        PLAYER:                 2,
        GUEST:                  3,
        MANAGER:                4,
        ASSISTANT:              5
    },
    GAME_STATES : {
        IDLE:                   1,
        AUTH:                   2,
        TITLE:                  3,
        CHOICES:                4,
        RESULT:                 5,
        RANKING:                6,
        STOPPED:                7,
        PAUSED:                 8,
        END:                    9,
        // Full-screen stage animation (intro before the first stop/activity,
        // "veamos cómo ha ido" on reaching a stop) - see server.js's
        // _show_interlude and client/src/views/Interlude.vue.
        INTERLUDE:              10,
    },
    ACTIVITY_TYPE : {
        QUIZ:                   1,
        QUIZ_MULTIPLE:          2,
        TRUE_FALSE:             3,
        RANGE:                  4,
        ORDER:                  5,
        TEXT:                   6,
        CROSSWORD:              7,
        // Legacy - sectors used to be a specially-typed row inserted into a
        // stage's ordered activity list. They're now a real table
        // (sector.model.js / RPC.REGISTER_SECTOR & co) so each one can carry
        // its own on-reach config (notify_email/pause/show_ranking/
        // show_feedback) and every stage can guarantee a mandatory first
        // sector. Kept reserved (not reused for a new type) only so old
        // exported/imported JSON activity dumps don't collide with an
        // unrelated type - nothing creates rows with this type anymore.
        SECTOR:                 8,
        // Non-interactive "content" activities - the player just consumes
        // them (see is_content_activity below). Entering one is what marks
        // it as done (choice ['viewed'], see components/type/Content.vue),
        // since actually watching/reading can't be reliably detected. They
        // never score: calc_score()/calc_question_result() have no case for
        // them, so every ranking sortcode treats them as 0 / not correct.
        IMAGE:                  9,
        VIDEO:                  10,
        PDF:                    11,
        HTML:                   12,
    },
    // Event mode, VIDEO activities (question.display_on): where the video
    // actually plays. SCREEN = only on the room's big screen (MANAGER
    // clients), players' phones just say "look at the screen". Online mode
    // has no big screen and always plays on the player's own device.
    MEDIA_DISPLAY : {
        ALL:                    'all',
        SCREEN:                 'screen',
    },
    // The "choice" a content activity is recorded with once the player
    // enters it - there's nothing to answer, only "seen".
    CONTENT_VIEWED_CHOICE:      'viewed',
    is_content_activity(type){
        return type == this.ACTIVITY_TYPE.IMAGE || type == this.ACTIVITY_TYPE.VIDEO
            || type == this.ACTIVITY_TYPE.PDF || type == this.ACTIVITY_TYPE.HTML;
    },
    // Accepts whatever an admin is likely to paste (a YouTube/Vimeo page
    // link, a youtu.be short link, or a direct/uploaded file URL) and says
    // how to play it: kind 'youtube'/'vimeo' (driven through each site's
    // player API - see components/VideoPlayer.vue - with `src` as a plain
    // embeddable iframe URL for previews), or a plain <video> 'file'.
    get_video_source(url){
        if(!url) return null;
        let m = url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
        if(m) return { kind: 'youtube', id: m[1], src: 'https://www.youtube.com/embed/' + m[1] + '?rel=0&playsinline=1' };
        m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        if(m) return { kind: 'vimeo', id: m[1], src: 'https://player.vimeo.com/video/' + m[1] };
        return { kind: 'file', src: url };
    },
    // Fallbacks for questions saved before title_duration/result_duration
    // existed (both live inside the question JSON blob, like duration/score -
    // see Form*.vue), and the small clock-sync buffer stage auto-play uses
    // when it launches an activity itself instead of an admin typing the
    // "seconds" field on the Comenzar modal (Panel.vue).
    STAGE_PLAYBACK : {
        TITLE_DURATION_FALLBACK:   5,
        RESULT_DURATION_FALLBACK:  8,
        SYNC_BUFFER_MS:            3000,
        // How long an automatic sector-triggered ranking stays on screen
        // before playback continues - there's no per-ranking equivalent of
        // a question's own result_duration to read this from.
        RANKING_DURATION_FALLBACK: 10,
        // Interlude animations (GAME_STATES.INTERLUDE) - deliberately short,
        // never more than ~10s of dead time for the room.
        INTRO_DURATION:            9,
        CHECKPOINT_DURATION:       7,
    },
    // Visual themes a season/event can pick (season.theme) - the rider on
    // the progress bar/animations and the wording (Salida/Meta/Parada...).
    // Only the ids live here, for server-side validation: the themes
    // themselves (SVG + texts) are client/src/themes/.
    THEME_IDS:                  ['cycling', 'camino', 'adventure'],
    DEFAULT_THEME:              'cycling',
    // Groundwork for "Implementación Etapas" (issue: activities will belong
    // to a Segment of a future Stage). Stages themselves depend on
    // Seasons/Events, which don't exist yet - this is just the
    // classification an activity carries meanwhile, plus the multiplier the
    // eventual scoring engine will read. score/duration keep working as they
    // do today; multiplier is additive, not a replacement, until that engine
    // is actually specified.
    SEGMENT_TYPES : {
        FLAT:                   1,
        MOUNTAIN:               2,
        SPRINT:                 3,
        TIME_TRIAL:             4,
    },
    // A ranking is a configurable scoring rule, not a hardcoded leaderboard -
    // one season can have several (see server/models/ranking.model.js). This
    // is the "sortcode": the only thing that decides how it's computed -
    // resolved to a concrete Ranking subclass through server/actions/
    // ranking/ranking-registry.js, computed server-side (RankingAction) and
    // sent to Ranking.vue already resolved into {label, display_value, rank}.
    //   POINTS - count of correct answers x the season's own base_score
    //            (season.model.js) - deliberately not each question's own
    //            score/multiplier, kept as a separate, simpler unit.
    //   TIME   - ranks by response time (faster wins).
    RANKING_CRITERIA : {
        POINTS:                 1,
        TIME:                   2,
    },
    // Which activities count toward it: just the stage the triggering
    // sector belongs to, or everything answered so far regardless of stage.
    // See RankingAction (server/actions/ranking-action.js).
    RANKING_SCOPES : {
        STAGE:                  1,
        GLOBAL:                 2,
    },
    // Runtime mode, set via MODE (server) / VUE_APP_MODE (client) env vars.
    // EVENT: single in-person live game (current behavior). ONLINE: reserved
    // for upcoming multi-game/remote-play model classes.
    APP_MODES : {
        EVENT:                  'event',
        ONLINE:                 'online',
    },
    GAME_STYLES : {
        title: {
            color: '#45506b'
        },
        small_title: {
            color: '#17202b'
        },
        question: {
            backgroundColor: 'rgba(250, 250, 249, 0.95)'
        },
        lobby_title: {
            color: '#fafaf9'
        },
        lobby_wait: {
            color: '#fafaf9'
        },
        ranking_end: {
            color: '#fafaf9'
        },
        ranking_end_teams: {
            color: '#fafaf9'
        },
        ranking_lines: {
            backgroundColor: '#00a7af'
        },
        end_lines: {
            backgroundColor: '#00a7af'
        },
        loading: {
            color: '#17202b'
        },
        loader: {
            borderColor: '#00a7af'
        }
    },
    GAME_IMAGES : {
        main_image: null,
        ranking_podium_image: null,
        activity_image: null,
        lobby_image: null,
        auth_image: null,
    },
    getDateTime() {
        var now     = new Date(); 
        var year    = now.getFullYear();
        var month   = now.getMonth()+1; 
        var day     = now.getDate();
        var hour    = now.getHours();
        var minute  = now.getMinutes();
        var second  = now.getSeconds(); 
        if(month.toString().length == 1) {
            month = '0'+month;
        }
        if(day.toString().length == 1) {
            day = '0'+day;
        }   
        if(hour.toString().length == 1) {
            hour = '0'+hour;
        }
        if(minute.toString().length == 1) {
            minute = '0'+minute;
        }
        if(second.toString().length == 1) {
            second = '0'+second;
        }   
        var dateTime = year+'/'+month+'/'+day+' '+hour+':'+minute+':'+second;   
        return dateTime;
    },
    get_activity_type(type){
        var activitylist = Object.keys(utils.ACTIVITY_TYPE);
        return activitylist[type];
    },
    get_activity_type_color(type) {
        // Every activity type shares one neutral, bordered badge style now -
        // the label text carries the distinction instead of a rainbow of
        // pastel backgrounds, to stay consistent with the rest of the UI.
        return "badge-activity-type";
    },
    get_game_state_label(state){
        let label = "none";
        switch(state){
            case this.GAME_STATES.IDLE: label = "IDLE"; break;
            case this.GAME_STATES.AUTH: label = "AUTH"; break;
            case this.GAME_STATES.TITLE: label = "TITLE"; break;
            case this.GAME_STATES.CHOICES: label = "CHOICES"; break;
            case this.GAME_STATES.RESULT: label = "RESULT"; break;
            case this.GAME_STATES.RANKING: label = "RANKING"; break;
            case this.GAME_STATES.STOPPED: label = "STOPPED"; break;
            case this.GAME_STATES.PAUSED: label = "PAUSED"; break;
            case this.GAME_STATES.END: label = "END"; break;
            case this.GAME_STATES.INTERLUDE: label = "INTERLUDE"; break;
        }
        return label;
    
    },
    get_activity_type_label(type){
        let label = "bg-secondary";
        switch(type){
            case this.ACTIVITY_TYPE.QUIZ: label = "QUIZ"; break;
            case this.ACTIVITY_TYPE.QUIZ_MULTIPLE: label = "QUIZ MULTIPLE"; break;
            case this.ACTIVITY_TYPE.TRUE_FALSE: label = "V / F"; break;
            case this.ACTIVITY_TYPE.RANGE: label = "RANGO"; break;
            case this.ACTIVITY_TYPE.ORDER: label = "ORDER"; break;
            case this.ACTIVITY_TYPE.TEXT: label = "TEXTO"; break;
            case this.ACTIVITY_TYPE.SECTOR: label = "SEPARADOR"; break;
            case this.ACTIVITY_TYPE.IMAGE: label = "IMAGEN"; break;
            case this.ACTIVITY_TYPE.VIDEO: label = "VÍDEO"; break;
            case this.ACTIVITY_TYPE.PDF: label = "PDF"; break;
            case this.ACTIVITY_TYPE.HTML: label = "CONTENIDO HTML"; break;
        }
        return label;
    },
    get_segment_label(segment){
        switch(segment){
            case this.SEGMENT_TYPES.FLAT: return "Llano";
            case this.SEGMENT_TYPES.MOUNTAIN: return "Montaña";
            case this.SEGMENT_TYPES.SPRINT: return "Sprint";
            case this.SEGMENT_TYPES.TIME_TRIAL: return "Contrarreloj";
        }
        return "-";
    },
    get_ranking_criterion_label(criterion){
        switch(criterion){
            case this.RANKING_CRITERIA.POINTS: return "Puntuación base";
            case this.RANKING_CRITERIA.TIME: return "Tiempo de respuesta";
        }
        return "-";
    },
    get_ranking_scope_label(scope){
        switch(scope){
            case this.RANKING_SCOPES.STAGE: return "Solo esta etapa";
            case this.RANKING_SCOPES.GLOBAL: return "Global (toda la temporada)";
        }
        return "-";
    },
    // A "season" is called "Evento" in single-event mode and "Temporada" in
    // online mode (which allows several at once) - see APP_MODES above.
    get_season_label(mode, plural){
        let label = (mode === this.APP_MODES.ONLINE) ? "Temporada" : "Evento";
        return plural ? label + "s" : label;
    },
    get_role_label(role){
        let label = "GUEST";
        switch(role){
            case this.USER_ROLES.ADMINISTRATOR: label = "ADMINISTRATOR"; break;
            case this.USER_ROLES.MANAGER: label = "MANAGER"; break;
            case this.USER_ROLES.ASSISTANT: label = "ASSISTANT"; break;
            case this.USER_ROLES.GUEST: label = "GUEST"; break;
            case this.USER_ROLES.PLAYER: label = "PLAYER"; break;
        }
        return label;
    },
    is_valid_parameter(param) {
        return param !== null && param !== undefined && param !== '';
    },
    timestamp_to_hms(timestamp) {
        // Convert the timestamp to milliseconds
        let date = new Date(timestamp);
      
        // Get hours, minutes, and seconds
        let hours = date.getUTCHours();
        let minutes = date.getUTCMinutes();
        let seconds = date.getUTCSeconds();
      
        // Format the result
        let formattedTime = this.pad_zero(hours) + ":" + this.pad_zero(minutes) + ":" + this.pad_zero(seconds);

        return formattedTime;
    },
    pad_zero(number) {
        return number < 10 ? "0" + number : number;
    },
    find_question(id)
    {
        var question = window.store._state.data.game.questions.find((q) => q.id == id);
        if(question)
            return question;
        
        return null;
    },
    // find_question_fn lets callers that don't have window.store (the online-
    // mode REST endpoints in server/server.js, which score against a
    // question fetched straight from the DB) plug in their own lookup -
    // defaults to the existing browser-only find_question() so every
    // existing 2-arg call site keeps working unchanged.
    calc_score(user_data, find_question_fn) {
        let totalScore = 0;
        find_question_fn = find_question_fn || this.find_question.bind(this);

        if (user_data && user_data.length > 0) {
            user_data.forEach(user_activity => {
                var q = find_question_fn(user_activity.question);
    
                if (q) {
                    // correctAnswer is missing/empty for question types this
                    // switch doesn't score (e.g. CROSSWORD) - fall back to an
                    // empty array so those just contribute 0 instead of
                    // throwing on the .length/.[0] access below.
                    let correctAnswer = q.question.correctAnswer || [];
                    let score_per_choice = correctAnswer.length > 0 ? q.question.score / correctAnswer.length : 0;
                    let response_time = this.get_answer_time(q.question.start_time, user_activity.timestamp);

                    // Calculate time-based score adjustment
                    let timeFactor = this.calculate_time_factor(response_time, q.question.duration);
                    let adjustedScore = score_per_choice * timeFactor;

                    switch (q.question.type) {
                        case this.ACTIVITY_TYPE.QUIZ:
                        case this.ACTIVITY_TYPE.TRUE_FALSE:
                        case this.ACTIVITY_TYPE.RANGE:
                            if (correctAnswer.length > 0 && user_activity.choice[0] == correctAnswer[0]) {
                                totalScore += adjustedScore;
                            }
                            break;

                        case this.ACTIVITY_TYPE.TEXT:
                            if (correctAnswer.length > 0 && user_activity.choice[0] != null
                                && String(user_activity.choice[0]).toLowerCase() == String(correctAnswer[0]).toLowerCase()) {
                                totalScore += adjustedScore;
                            }
                            break;

                        case this.ACTIVITY_TYPE.QUIZ_MULTIPLE:
                            (user_activity.choice || []).forEach(ch => {
                                if (correctAnswer.includes(ch)) {
                                    totalScore += adjustedScore;
                                }
                            });
                            break;
                    }
                }
            });
        }

        // Limit totalScore to two decimal places
        totalScore = parseFloat(totalScore.toFixed(2));
    
        return totalScore;
    },
    // Same per-answer scoring rules as calc_score(), but scoped to a single
    // question - used by the Result screen to show "you got it right / +N
    // points" for the question that was just answered, rather than the
    // running total across the whole game.
    calc_question_result(user_data, question_id, find_question_fn) {
        let score = 0;
        let answered = false;
        find_question_fn = find_question_fn || this.find_question.bind(this);

        const user_activity = (user_data || []).find((d) => d.question == question_id);
        if (user_activity) {
            answered = true;
            var q = find_question_fn(question_id);

            if (q) {
                let correctAnswer = q.question.correctAnswer || [];
                let score_per_choice = correctAnswer.length > 0 ? q.question.score / correctAnswer.length : 0;
                let response_time = this.get_answer_time(q.question.start_time, user_activity.timestamp);
                let timeFactor = this.calculate_time_factor(response_time, q.question.duration);
                let adjustedScore = score_per_choice * timeFactor;

                switch (q.question.type) {
                    case this.ACTIVITY_TYPE.QUIZ:
                    case this.ACTIVITY_TYPE.TRUE_FALSE:
                    case this.ACTIVITY_TYPE.RANGE:
                        if (correctAnswer.length > 0 && user_activity.choice[0] == correctAnswer[0]) {
                            score += adjustedScore;
                        }
                        break;

                    case this.ACTIVITY_TYPE.TEXT:
                        if (correctAnswer.length > 0 && user_activity.choice[0] != null
                            && String(user_activity.choice[0]).toLowerCase() == String(correctAnswer[0]).toLowerCase()) {
                            score += adjustedScore;
                        }
                        break;

                    case this.ACTIVITY_TYPE.QUIZ_MULTIPLE:
                        (user_activity.choice || []).forEach(ch => {
                            if (correctAnswer.includes(ch)) {
                                score += adjustedScore;
                            }
                        });
                        break;
                }
            }
        }

        score = parseFloat(score.toFixed(2));
        return { correct: score > 0, score, answered };
    },
    calculate_time_factor(response_time, max_duration) {
        // Calculate the time factor based on response time and maximum allowed duration
        const timeFactor = Math.max(0, 1 - response_time / max_duration);
        return timeFactor;
    },
    get_answer_time(start_time, end_time) {
        // Calculate the time taken to answer a question in seconds
        if(start_time<end_time)
            return (end_time - start_time) / 1000;
        return null;
    }    
};

module.exports = utils;